export const TRIP_NUMBERS_FILTER_TEXT = {
	outerLabel: 'Trip Number',
	inputLabel: 'Trip number',
	placeholder: 'E.g. 01, 02',
	infoError: 'Should contain only numbers!',
	optionsLabel: 'Lines',
	optionSubtitle: 'Select to add',
};
